export const ACCESS_CODE_RETRY_PARAM = "codigo";

/** Plan page with the access code prefilled so the user can retry it. */
export function accessCodeRetryPath(code: string): string {
  const params = new URLSearchParams({
    [ACCESS_CODE_RETRY_PARAM]: code.trim(),
  });
  return `/seleccionar-plan?${params.toString()}`;
}
